import styles
    from "./MaintenanceIntervalReport.module.css";


const MaintenanceIntervalReport = ({
    data,
}) => {

    if (!data) {
        return null;
    }


    const current =
        data.current;


    const previous =
        data.previous;


    const comparison =
        data.comparison;


    return (

        <section className={styles.card}>

            <div className={styles.header}>

                <div>

                    <span className={styles.eyebrow}>
                        گزارش نگهداری
                    </span>

                    <h2>
                        فاصله بین هزینه‌ها
                    </h2>

                </div>

                <span className={styles.badge}>
                    سرویس
                </span>

            </div>


            <div className={styles.mainMetric}>

                <strong>
                    {current?.averageDays}
                </strong>

                <span>
                    روز
                </span>

            </div>


            <p className={styles.description}>
                به‌طور متوسط هر{" "}
                <strong>
                    {current?.averageDays}
                </strong>{" "}
                روز یک هزینه یا سرویس برای این خودرو
                ثبت شده است.
            </p>


            <div className={styles.stats}>

                <div className={styles.stat}>

                    <span>
                        دوره فعلی
                    </span>

                    <strong>
                        {current?.averageDays}
                        {" "}
                        روز
                    </strong>

                    <small>
                        {current?.eventCount}
                        {" "}
                        رویداد
                    </small>

                </div>


                <div className={styles.stat}>

                    <span>
                        دوره قبل
                    </span>

                    <strong>
                        {previous?.averageDays}
                        {" "}
                        روز
                    </strong>

                    <small>
                        {previous?.eventCount}
                        {" "}
                        رویداد
                    </small>

                </div>

            </div>


            <div className={styles.comparison}>

                <span>
                    وضعیت نسبت به دوره قبل
                </span>


                <strong>

                    {

                        comparison?.trend === "better"
                            ? "بهتر شده"
                            : comparison?.trend === "worse"
                                ? "بیشتر شده"
                                : "بدون تغییر"

                    }

                </strong>


                <div>

                    <span>
                        {comparison?.changeDays}
                        {" "}
                        روز
                    </span>

                    <span>
                        ({comparison?.changePercentage}%)
                    </span>

                </div>

            </div>


        </section>

    );

};


export default MaintenanceIntervalReport;
